module.exports = "https://static.wagwalking.com/_next/static/images/pet-9-c686ce92c2b30947e1ad75affe747754.png";